"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyToAnyDetector = void 0;
const tslib_1 = require("tslib");
const fee_reference_based_detector_1 = require("./fee-reference-based-detector");
const utils_1 = require("@requestnetwork/utils");
/**
 * Abstract class to extend to get the payment balance of conversion requests
 */
class AnyToAnyDetector extends fee_reference_based_detector_1.FeeReferenceBasedDetector {
    /**
     * @param extension The advanced logic payment network extension, with conversion
     */
    constructor(paymentNetworkId, extension, currencyManager) {
        super(paymentNetworkId, extension, currencyManager);
    }
    /**
     * Creates the extensions data for the creation of this extension.
     * Will set a salt if none is already given
     *
     * @param paymentNetworkCreationParameters Parameters to create the extension
     * @returns The extensionData object
     */
    createExtensionsDataForCreation(paymentNetworkCreationParameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // If no salt is given, generate one
            paymentNetworkCreationParameters.salt =
                paymentNetworkCreationParameters.salt || (yield (0, utils_1.generate8randomBytes)());
            return this.extension.createCreationAction(paymentNetworkCreationParameters);
        });
    }
}
exports.AnyToAnyDetector = AnyToAnyDetector;
